import { render, staticRenderFns } from "./lk.vue?vue&type=template&id=3c1d9054"
import script from "./lk.vue?vue&type=script&lang=js"
export * from "./lk.vue?vue&type=script&lang=js"
import style0 from "./lk.vue?vue&type=style&index=0&id=3c1d9054&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports